import { __extends } from "tslib";
import { GetBucketCorsOutput, GetBucketCorsRequest } from "../models/index";
import { deserializeAws_restXmlGetBucketCorsCommand, serializeAws_restXmlGetBucketCorsCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetBucketCorsCommand = /** @class */ (function (_super) {
    __extends(GetBucketCorsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetBucketCorsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetBucketCorsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetBucketCorsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetBucketCorsOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetBucketCorsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlGetBucketCorsCommand(input, context);
    };
    GetBucketCorsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlGetBucketCorsCommand(output, context);
    };
    return GetBucketCorsCommand;
}($Command));
export { GetBucketCorsCommand };
//# sourceMappingURL=GetBucketCorsCommand.js.map